import { render, staticRenderFns } from "./WorkingProgressImport.vue?vue&type=template&id=da7496b0"
import script from "./WorkingProgressImport.vue?vue&type=script&lang=js"
export * from "./WorkingProgressImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da7496b0')) {
      api.createRecord('da7496b0', component.options)
    } else {
      api.reload('da7496b0', component.options)
    }
    module.hot.accept("./WorkingProgressImport.vue?vue&type=template&id=da7496b0", function () {
      api.rerender('da7496b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/WorkingProgressImport.vue"
export default component.exports